import React from 'react'
import * as S from './EmptyDialogs.styles'

export const EmptyDialogs: React.FC = () => {
  return (
    <S.Container>
      <S.Image src="/images/platform/gray-chain.svg" alt="Empty" />
      <S.Text>No conversations found</S.Text>
    </S.Container>
  )
}

export default EmptyDialogs
